module.exports = __webpack_public_path__ + "static/images/dnf-video.6d0d0a0.png";